import { put, select, takeEvery } from 'redux-saga/effects';
import {
  TRACK_CHECK_PERCENTAGE,
  TRACK_EXTERNAL,
  TRACK_START,
  TRACK_QUARTER,
  TRACK_HALF,
  TRACK_THREE_QUARTERS,
  TRACK_END,
} from '../actions/types';
import {
  loadCustomOptions,
  trackQuarter,
  trackHalf,
  trackThreeQuarters,
  trackEnd,
} from '../actions/tracking';
import { asPercent } from '../../utils/math';
import { PLAYER_TRACK } from '../../utils/messages';

export function* checkPlaytimePercentage(selectPlaytime, selectDuration, selectNextMilestone) {
  const playTime = yield select(selectPlaytime);
  const duration = yield select(selectDuration);

  const nextMilestone = yield select(selectNextMilestone);
  const percentage = asPercent(playTime, duration);

  if (percentage >= 25 && nextMilestone === 25) {
    yield put(trackQuarter());
  }
  if (percentage >= 50 && nextMilestone === 50) {
    yield put(trackHalf());
  }
  if (percentage >= 75 && nextMilestone === 75) {
    yield put(trackThreeQuarters());
  }
  if (percentage >= 99.9 && nextMilestone === 100) {
    yield put(trackEnd());
  }
}

export function* track(selectPlayerId, selectTitle, selectContentId, selectSource, eventName) {
  const id = yield select(selectContentId);
  const source = yield select(selectSource);
  const title = yield select(selectTitle);

  const eventDetail = {
    id,
    source,
    title,
  };

  window.parent.postMessage({
    type: PLAYER_TRACK,
    data: {
      playerId: yield select(selectPlayerId),
      eventName,
      eventDetail,
    },
  }, '*');
}

export function* useCustomOptions(selectNextMilestone, selectCustomId, selectCustomSource) {
  const nextMilestone = yield select(selectNextMilestone);
  if (nextMilestone === 0) {
    const customArticleId = yield select(selectCustomId);
    const customSource = yield select(selectCustomSource);
    yield put(loadCustomOptions({ customArticleId, customSource }));
  }
}

export const trackingSaga = ({
  selectPlayerId,
  selectPlaytime,
  selectDuration,
  selectNextMilestone,
  selectTitle,
  selectContentId,
  selectSource,
  selectCustomId,
  selectCustomSource,
}) => function* saga() {
  yield takeEvery(TRACK_CHECK_PERCENTAGE, checkPlaytimePercentage, selectPlaytime, selectDuration, selectNextMilestone);
  yield takeEvery(TRACK_EXTERNAL, useCustomOptions, selectNextMilestone, selectCustomId, selectCustomSource);
  yield takeEvery(TRACK_START, track, selectPlayerId, selectTitle, selectContentId, selectSource, 'start');
  yield takeEvery(TRACK_QUARTER, track, selectPlayerId, selectTitle, selectContentId, selectSource, '25%');
  yield takeEvery(TRACK_HALF, track, selectPlayerId, selectTitle, selectContentId, selectSource, '50%');
  yield takeEvery(TRACK_THREE_QUARTERS, track, selectPlayerId, selectTitle, selectContentId, selectSource, '75%');
  yield takeEvery(TRACK_END, track, selectPlayerId, selectTitle, selectContentId, selectSource, 'complete');
};
